export default "__VITE_ASSET__i_QsC_qd__"